import {
  required,
  between,
  requiredIf,
} from 'vuelidate/lib/validators';
import parametersFields from './parametersFields';

const equilibriumCurve = {
  required,
};
const gasVolume = {
  required,
  between: between(
    parametersFields.gasVolume.minValue,
    parametersFields.gasVolume.maxValue,
  ),
};
const shouldConsiderStabilizationTime = {
  required,
};
const paperActivationEnergy = parameters => ({
  required: requiredIf(() => parameters.shouldConsiderStabilizationTime),
  between: between(
    parametersFields.paperActivationEnergy.minValue,
    parametersFields.paperActivationEnergy.maxValue,
  ),
});
const paperThickness = parameters => ({
  required: requiredIf(() => parameters.shouldConsiderStabilizationTime),
  between: between(
    parametersFields.paperThickness.minValue,
    parametersFields.paperThickness.maxValue,
  ),
});
const shouldConsiderOilType = {
  required,
};
const oilSolubilityConstant = {
  required,
  between: between(
    parametersFields.oilSolubilityConstant.minValue,
    parametersFields.oilSolubilityConstant.maxValue,
  ),
};
const atmosphericPressure = {
  required,
  between: between(
    parametersFields.atmosphericPressure.minValue,
    parametersFields.atmosphericPressure.maxValue,
  ),
};
const referenceTemperature = {
  required,
  between: between(
    parametersFields.referenceTemperature.minValue,
    parametersFields.referenceTemperature.maxValue,
  ),
};
const estimatedHeightBetweenConservatorAndWindingTop = {
  required,
  between: between(
    parametersFields.estimatedHeightBetweenConservatorAndWindingTop.minValue,
    parametersFields.estimatedHeightBetweenConservatorAndWindingTop.maxValue,
  ),
};
const windings = {
  $each: {
    bubbleFormationMinimumTemperatureDifference: {
      required,
      between: between(
        parametersFields.bubbleFormationMinimumTemperatureDifference.minValue,
        parametersFields.bubbleFormationMinimumTemperatureDifference.maxValue,
      ),
    },
    admissibleWaterOnPaper: {
      required,
      between: between(
        parametersFields.admissibleWaterOnPaper.minValue,
        parametersFields.admissibleWaterOnPaper.maxValue,
      ),
    },
  },
};

export default (parameters) => {
  if (parameters.shouldConsiderStabilizationTime) {
    return {
      parameters: {
        equilibriumCurve,
        gasVolume,
        shouldConsiderStabilizationTime,
        paperActivationEnergy: paperActivationEnergy(parameters),
        paperThickness: paperThickness(parameters),
        shouldConsiderOilType,
        oilSolubilityConstant,
        atmosphericPressure,
        referenceTemperature,
        estimatedHeightBetweenConservatorAndWindingTop,
      },
      windings,
    };
  }

  return {
    parameters: {
      equilibriumCurve,
      gasVolume,
      shouldConsiderStabilizationTime,
      shouldConsiderOilType,
      oilSolubilityConstant,
      atmosphericPressure,
      referenceTemperature,
      estimatedHeightBetweenConservatorAndWindingTop,
    },
    windings,
  };
};
